import React from "react";
import {
  StyledHeadlines,
  Heading,
  InfographicList,
  InfographicWrapper,
} from "./Headlines.style";

import Infographic from "../../components/Infographic";
import GraphDown from "../../components/Infographic/icons/GraphDown";
import GraphUp from "../../components/Infographic/icons/GraphUp";
import House from "../../components/Infographic/icons/House";
import { useTranslation } from "react-i18next";

/**
 * Headlines page /headlines
 */
const Headlines = ({ figures }) => {
  const { t } = useTranslation();

  const { transactions_change, annual_change, quarter_change, average_price } =
    figures;

  // let transactionsLabel = t('Transactions');
  // if (transactions_change > 0) {
  //     transactionsLabel = t('Increase in transactions');
  // } else if (transactions_change < 0) {
  //     transactionsLabel = t('Fall in transactions');
  // }

  return (
    <StyledHeadlines>
      <Heading>{t("headlines.heading")}</Heading>

      <InfographicList>
        <InfographicWrapper>
          <Infographic
            title={t("headlines.annualChangeHeading")}
            figure={annual_change + "%"}
            image={
              annual_change > 0 ? (
                <GraphUp
                  lineColor="#A71C56"
                  graphColor="#007961"
                  style={{ marginRight: "auto" }}
                />
              ) : (
                <GraphDown
                  lineColor="#A71C56"
                  graphColor="#007961"
                  style={{ marginLeft: "auto" }}
                />
              )
            }
            style={{ backgroundColor: "#DFDAD5" }}
            titleColor="#007961"
            figureColor="#A71C56"
            imagePosition={annual_change > 0 ? "right" : "left"}
          />
        </InfographicWrapper>

        <InfographicWrapper>
          <Infographic
            title={t("headlines.quarterlyChangeHeading")}
            figure={quarter_change + "%"}
            image={
              quarter_change > 0 ? (
                <GraphUp
                  lineColor="#A71C56"
                  graphColor="#007961"
                  style={{ marginRight: "auto" }}
                />
              ) : (
                <GraphDown
                  lineColor="#A71C56"
                  graphColor="#007961"
                  style={{ marginLeft: "auto" }}
                />
              )
            }
            style={{ backgroundColor: "#5A0231" }}
            titleColor="#DFDAD5"
            figureColor="#DFDAD5"
            imagePosition={annual_change > 0 ? "right" : "left"}
          />
        </InfographicWrapper>

        <InfographicWrapper>
          <Infographic
            title={t("headlines.averageHousePriceHeading")}
            figure={average_price.toLocaleString("en-GB", {
              style: "currency",
              currency: "GBP",
              minimumFractionDigits: 0,
            })}
            image={<House style={{ maxWidth: "100%", height: "auto" }} />}
            style={{ backgroundColor: "#A71C56" }}
            titleColor="#DFDAD5"
            figureColor="#DFDAD5"
            imagePosition="right"
          />
        </InfographicWrapper>

        <InfographicWrapper>
          <Infographic
            title={
              transactions_change > 0
                ? t("headlines.transactionsHeadingIncrease")
                : t("headlines.transactionsHeadingDecrease")
            }
            figure={`${transactions_change}%`}
            summary={t("headlines.vs", {
              a1: "2",
              a2: 2021,
              b1: "1",
              b2: 2021,
            })}
            image={
              transactions_change > 0 ? (
                <GraphUp
                  lineColor="#A71C56"
                  graphColor="#5A0231"
                  style={{ marginRight: "auto" }}
                />
              ) : (
                <GraphDown
                  lineColor="#A71C56"
                  graphColor="#5A0231"
                  style={{ marginLeft: "auto" }}
                />
              )
            }
            style={{ backgroundColor: "#007961" }}
            titleColor="#DFDAD5"
            figureColor="#DFDAD5"
            imagePosition="right"
          />
        </InfographicWrapper>
      </InfographicList>
    </StyledHeadlines>
  );
};

export default Headlines;
